<template>
	<div v-if="parent_data" class="el-closed-question" :class="{ 'can-change': is_editable, 'dense': dense }" @click="change()">
		<div class="question-label">
			<div>
			{{ label }}
			</div>
			<div>
				<slot/>
			</div>
		</div>
		<span class="question-value">
			<span v-if="hasOptions">{{ value }}</span>
			<template v-else>
				<span v-if="value === true">OUI</span>
				<span v-else-if="value === false || !allowNC">NON</span>
				<span v-else>NC</span>
			</template>
		</span>
	</div>
</template>

<script>
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-closed-question",
	mixins: [ ElementMixin ],
	props: {
		label: { default: "" },
		editable: { default: false },
		dense: { default: false },
		allowNC: { default: false },
		options: {
			type: Array,
			required: false,
			default: undefined
		}
	},
	computed: {
		hasOptions () {
			return Array.isArray(this.options) && this.options.length;
		}
	},
	methods: {
		change: function () {
			if (this.is_editable) {
				if(this.hasOptions) {
					const currentValueIndex = this.options.indexOf(this.value);
					const newValueIndex = currentValueIndex + 1 >= this.options.length ? 0 : currentValueIndex + 1;
					this.edit_study(this.options[newValueIndex]);
				} else if(this.allowNC) {
					if(this.value === false) {
						this.edit_study(undefined);
					} else if(this.value === true) {
						this.edit_study(false);
					} else {
						this.edit_study(true);
					}
				} else {
					this.edit_study(!this.value);
				}
			}
		}
	}
};
</script>

<style lang="stylus">
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.el-closed-question
	padding 4px 8px 4px 16px
	margin-bottom 4px
	min-height 40px
	background-color #eee
	border-radius radius
	display flex
	align-items center
	flex-wrap wrap
	justify-content space-between
	&.dense
		min-height 34px
	&.can-change
		cursor pointer
		box-shadow 0 0 0 1px purple
		background-color lighten(purple, 85%)
		&:hover
			background-color alpha(purple, 20%)
	.question-label
		max-width 75%
	.question-value
		display flex
		align-items center
		min-height 24px
		padding 0 8px
		background-color main_color
		border-radius radius
		color #fff
		line-height @height


</style>